import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M37.841 9.716q.186 3.079.186 7.999 0 10.57-.856 25.429a1.966 1.966 0 0 1-3.353 1.277l-8.022-8.022c-.601-.601-.843-.764-1.16-.86a1.25 1.25 0 0 0-.744 0c-.319.096-.56.259-1.161.86l-8.025 8.025a1.966 1.966 0 0 1-3.353-1.274Q10.5 28.68 10.5 17.81q0-4.982.18-8.077a6.88 6.88 0 0 1 6.255-6.455Q20.035 3 24.263 3q4.225 0 7.322.277a6.88 6.88 0 0 1 6.256 6.44m-1.78 7.999q0-4.868-.183-7.88a4.916 4.916 0 0 0-4.468-4.6q-3.003-.269-7.147-.269-4.147 0-7.152.27a4.916 4.916 0 0 0-4.469 4.61q-.176 3.033-.176 7.964 0 10.808.85 25.224l8.024-8.025c.812-.811 1.312-1.15 1.981-1.352a3.2 3.2 0 0 1 1.884 0c.67.203 1.17.54 1.982 1.352l8.021 8.022q.853-14.806.853-25.316m-11.798-.376 4.22-4.22c.928-.927 2.318.463 1.391 1.39l-4.22 4.22 4.22 4.221c.927.927-.463 2.317-1.39 1.39l-4.22-4.22-4.22 4.22c-.928.927-2.318-.463-1.391-1.39l4.22-4.22-4.22-4.22c-.927-.928.463-2.318 1.39-1.391z",
      clipRule: "evenodd"
    }
  )
);
var SvgBookmarkDeleteOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var BookmarkDeleteOutlined_default = SvgBookmarkDeleteOutlined;

export { BookmarkDeleteOutlined_default as default };
